export class RejectionReasonModel {
    name: string;
    code: string;
}